import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';
import {FormLinkType} from '../models/JsonTypes';
import {formulaireFormEdit} from '../routes';
import Form from '../models/Form';

const translationPrefix = 'kilowhat-formulaire.forum.form-create.';

interface NewFormModalAttrs extends  IInternalModalAttrs {
    linkType: FormLinkType
}

export default class NewFormModal extends Modal<NewFormModalAttrs> {
    formTitle: string = '';
    dirty: boolean = false;

    className() {
        return 'FormulaireModal FormulaireTheme Modal--small';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    content() {
        return m('.Modal-body', [
            m('.Form-group', [
                m('label', app.translator.trans(translationPrefix + 'field.title')),
                m('input.FormControl', {
                    type: 'text',
                    value: this.formTitle,
                    oninput: withAttr('value', (value: string) => {
                        this.formTitle = value;
                        this.dirty = true;
                    }),
                })
            ]),
            m('.ButtonGroup', [
                Button.component({
                    type: 'submit',
                    className: 'Button Button--primary',
                    loading: this.loading,
                    disabled: !this.dirty,
                }, app.translator.trans(translationPrefix + 'button.create')),
            ]),
        ]);
    }

    onsubmit(event: Event) {
        event.preventDefault();

        this.loading = true;

        app.store.createRecord<Form>('formulaire-forms').save({
            title: this.formTitle,
            private_title: this.formTitle,
            link_type: this.attrs.linkType,
            // Enable submissions by default on standalone forms since they can't be found easily
            // We don't do the same for discussion/user fields since those would become immediately visible
            accept_submissions: this.attrs.linkType === null,
        }, {
            errorHandler: this.onerror.bind(this),
        }).then(form => {
            app.modal.close();

            m.route.set(formulaireFormEdit(form));
        });
    }
}
